export const Loading = ({ text = 'Chargement...' }) => (
  <div className="loading-wrap">
    <div className="spinner" />
    <span style={{ fontSize: 13, color: 'var(--text2)' }}>{text}</span>
  </div>
);

export const EmptyState = ({ icon = '📭', title = 'Aucun résultat', text = '', action }) => (
  <div className="empty-state">
    <div className="empty-icon">{icon}</div>
    <div className="empty-title">{title}</div>
    {text && <div className="empty-text">{text}</div>}
    {action && <div style={{ marginTop: 16 }}>{action}</div>}
  </div>
);

export const ApiError = ({ message, onRetry }) => (
  <div style={{ padding: '40px 20px', textAlign: 'center' }}>
    <div style={{ fontSize: 40, marginBottom: 14 }}>⚠️</div>
    <div style={{ fontWeight: 600, marginBottom: 8 }}>Erreur de chargement</div>
    <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20, maxWidth: 400, margin: '0 auto 20px' }}>
      {message || 'Impossible de contacter le serveur. Vérifiez que le backend est en ligne.'}
    </div>
    {onRetry && (
      <button className="btn btn-secondary" onClick={onRetry}>
        ↺ Réessayer
      </button>
    )}
  </div>
);
